const countdownElement = document.querySelector('.countdown');
const targetDateStr = countdownElement.getAttribute('data-count-down');
const targetDate = new Date(targetDateStr);

function updateCountdown() {
  const now = new Date();
  const timeDifference = targetDate - now;

  if (timeDifference <= 0) {
    countdownElement.style.display = 'none'; // Hide countdown when time is up
    return;
  }

  // Calculate days, hours, minutes, seconds
  const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  // Update the HTML with the values
  document.getElementById('countdown-days').textContent = days;
  document.getElementById('countdown-hours').textContent = hours;
  document.getElementById('countdown-minutes').textContent = minutes;
  document.getElementById('countdown-seconds').textContent = seconds;

  // Handle singular and plural labels
  document.getElementById('days-label').textContent = days === 1 ? 'DAY' : 'DAYS';
  document.getElementById('hours-label').textContent = hours === 1 ? 'HR' : 'HRS';
  document.getElementById('minutes-label').textContent = minutes === 1 ? 'MIN' : 'MIN';
  document.getElementById('seconds-label').textContent = seconds === 1 ? 'SEC' : 'SEC';
}

// Run the updateCountdown function every second
const countdownInterval = setInterval(function() {
  updateCountdown();

  if (new Date() >= targetDate) {
    clearInterval(countdownInterval);
  }
}, 1000);